"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = onInput;
const On_1 = require("../../Framework/Decorators/On");
/**
 * Unlike the `change` event, this event listens for any and all
 * input events on select, textarea or input fields.
 *
 * @param role The data role to match on. Different matching-patterns can be prefixed. Supported: ~, ^, &, *, |
 *             See SelectorHelper.createDataRoleSelector
 * @param options
 * @see SelectorHelper.createDataRoleSelector
 */
function onInput(role, options) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, On_1.default)('input', role, options);
}
//# sourceMappingURL=OnInput.js.map